/**
 * What the call page shows for a recording.
 *
 * A 404 is the ordinary answer, not an error: recording is off unless the restaurant turns it on, and files
 * are deleted after 7 days. So it reads as "no recording" with the reason, never as something broken.
 */
export type RecordingView =
  | { kind: "loading" }
  | { kind: "none" }
  | { kind: "error"; message: string }
  | { kind: "ready"; url: string };

export function recordingView(input: {
  loading: boolean;
  url?: string;
  errorStatus?: number;
  errorMessage?: string;
}): RecordingView {
  if (input.loading) return { kind: "loading" };
  if (input.url) return { kind: "ready", url: input.url };
  if (input.errorStatus === 404) return { kind: "none" };
  if (input.errorStatus !== undefined || input.errorMessage) {
    return { kind: "error", message: input.errorMessage ?? `request failed (${input.errorStatus})` };
  }
  return { kind: "none" };
}

export const NO_RECORDING_HINT =
  "Calls are recorded only while “Record calls” is on in Settings. Recordings are kept for 7 days.";
